/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { OrganizationType } from './organizationType';

export interface OrganizationUpdateRequest { 
    specialty_ids?: Array<string>;
    disease_ids: Array<string>;
    organization_type?: OrganizationType;
    website?: string;
    organization_name: string;
    alternative_names?: Array<string>;
}